import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-pos-payment-yoyo',
  templateUrl: './pos-payment-yoyo.component.html',
  styleUrls: ['./pos-payment-yoyo.component.scss']
})
export class PosPaymentYoyoComponent implements OnInit, OnDestroy {
  @Input() amountOutstanding: number;
  @Input() storeId: number;
  @Input() containerId: number;
  @Input() containerDesc: string
  @Input() equipmentTypeCode: string;
  @Input() paymentType: string;
  @Input() salesOrderNumber: string;
  @Input() invoiceNumber: string;

  @Output() formChanged: EventEmitter<any> = new EventEmitter<any>(null);

  form: FormGroup;
  formSubscription: Subscription;
  wiCodeDetails: any = null;

  constructor(
    private fb: FormBuilder,
    private baseService: BaseService,
    private dialog: MatDialog
  ) {
    this.form = fb.group({
      amountTendered: [null, Validators.compose([Validators.required, Validators.min(1)])],
      amountOutstanding: [null],
      amountDifference: [null],
      wiCode: [null, Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(20)])],
      validationRequestId: [null, Validators.compose([Validators.required])],
      vspName: [null],
      couponValue: [null],
    });
  }

  ngOnInit() {
    if (this.paymentType && (this.paymentType === 'REFUND' || this.paymentType === 'DEPOSIT-REFUND')) {
      this.form.controls['amountTendered'].setValidators(Validators.compose([Validators.required, Validators.max(-1)]));
    } else {
      this.form.controls['amountTendered'].setValidators(Validators.compose([Validators.required, Validators.min(1)]));
    }

    this.form.controls['amountOutstanding'].disable();
    this.form.controls['amountDifference'].disable();
    this.form.controls['vspName'].disable();
    this.form.controls['couponValue'].disable();

    this.amountTenderedChanged();
    // this.amountTenderedFocusOut();

    this.formChanged.emit({
      containerId: this.containerId,
      equipmentTypeCode: this.equipmentTypeCode,
      formValue: this.form.getRawValue(),
      formValid: this.form.valid,
    });

    this.formSubscription = this.form.valueChanges.subscribe(s => {
      this.formChanged.emit({
        containerId: this.containerId,
        equipmentTypeCode: this.equipmentTypeCode,
        formValue: this.form.getRawValue(),
        formValid: this.form.valid,
      });
    });
  }

  ngOnDestroy(): void {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  amountTenderedChanged() {
    const amountTendered = +this.form.value.amountTendered || 0;
    const amountToPay = +this.amountOutstanding || 0;
    const minusOutstanding = amountTendered - amountToPay;

    this.form.controls['amountOutstanding'].setValue(+amountToPay.toFixed(2));
    this.form.controls['amountDifference'].setValue(+minusOutstanding.toFixed(2));

  }

  amountTenderedFocusOut() {
    if(!this.form.value.amountTendered) return;

    const amountTendered = +this.form.value.amountTendered || 0;
    this.form.controls['amountTendered'].setValue(+amountTendered.toFixed(2));
  }

  validate() {
    this.wiCodeDetails = null;
    this.form.controls['validationRequestId'].reset();
    this.form.updateValueAndValidity();

    const dialogData: OiGroupDialogData = {
      title: 'Validating YOYO Voucher',
      function: 'portal_oi_group_payment_validate_yoyo_voucher',
      postBody: Object.assign(this.form.getRawValue(), { storeId: this.storeId, salesOrderNumber: this.salesOrderNumber, invoiceNumber: this.invoiceNumber, portalProcess: this.paymentType && (this.paymentType === 'REFUND' || this.paymentType === 'DEPOSIT-REFUND') ? 'REFUND' : 'PAYMENT' })
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
        this.baseService.executeCommand<any>('portal_pos_payment_yoyo_validation_details', oiResult.data).subscribe(detailResponse => {
          if (detailResponse.responseCode === 0) {
            this.wiCodeDetails = detailResponse.data;

            this.form.controls['validationRequestId'].setValue(this.wiCodeDetails.requestId);
            this.form.controls['vspName'].setValue(this.wiCodeDetails.vspName);
            this.form.controls['couponValue'].setValue(this.wiCodeDetails.couponValue);
            this.form.controls['wiCode'].disable();

            if (this.wiCodeDetails.hasVoucher) {
              this.form.controls['amountTendered'].setValidators([Validators.required, Validators.min(this.wiCodeDetails.couponValue), Validators.max(this.wiCodeDetails.couponValue)]);
            } else {
              this.form.controls['amountTendered'].setValidators([Validators.required, Validators.min(20), Validators.max(this.amountOutstanding)]);
            }
            this.form.updateValueAndValidity();
          }
        });
      }
    });
  }

  resetValidation() {
    this.wiCodeDetails = null;
    this.form.controls['validationRequestId'].reset();
    this.form.controls['wiCode'].reset();
    this.form.controls['vspName'].reset();
    this.form.controls['couponValue'].reset();
    this.form.controls['amountTendered'].reset();
    this.form.controls['wiCode'].enable();
    this.form.controls['amountTendered'].setValidators([Validators.required, Validators.min(1)]);
    this.form.updateValueAndValidity();
  }

}
